import { useState } from "react";
import {
  CalendarClock,
  CalendarFold,
  ChartNoAxesColumn} from "lucide-react";
import ExploreItem from "./explore-item";
import { Button } from "@/components/ui/button";
import { Route as revenueRoute } from '@/routes/(inventory)/branch/_layout/accounts/profit-loss/index'
import { useNavigate } from "@tanstack/react-router";

const Explore = () => {
  const { type, time_compare, moving_average, moving_average_days } = revenueRoute.useSearch()
  const navigate = useNavigate();

  return (
    <div className="flex flex-col divide-y-[0.5px] font-light">
      <ExploreItem
        icon={<ChartNoAxesColumn className="w-4 h-4" />}
        text="Compare"
        defaultExpanded={time_compare || moving_average}
        content={
          <div className="grid gap-2">
            <h4 className="font-medium leading-none">Time</h4>
            <hr />
            <div className="">
              <Button variant={time_compare ? 'secondary' : 'ghost'} className="w-full justify-start p-0 font-light" onClick={() => {
                navigate({
                  search: {
                    time_compare: !time_compare,
                    type,
                    moving_average: false
                  }
                })
              }}>
                <CalendarFold className="mr-2 p-1 text-gray-600" /> Previous period
              </Button>
            </div>
            <h4 className="font-medium leading-none mt-4">Moving Average</h4>
            <hr />
            <div className="grid">
              <Button variant={moving_average && moving_average_days === 7 ? 'secondary' : 'ghost'} className="w-full justify-start p-0 font-light" onClick={() => {
                navigate({
                  search: {
                    time_compare: false,
                    type,
                    moving_average: moving_average && moving_average_days === 7 ? false : true,
                    moving_average_days: 7
                  }
                })
              }}>
                <CalendarClock className="mr-2 p-1 text-gray-600" /> 7-day average
              </Button>
              <Button variant={moving_average && moving_average_days === 28 ? 'secondary' : 'ghost'} className="w-full justify-start p-0 font-light" onClick={() => {
                navigate({
                  search: {
                    time_compare: false,
                    type,
                    moving_average: moving_average && moving_average_days === 28 ? false : true,
                    moving_average_days: 28
                  }
                })
              }}>
                <CalendarClock className="mr-2 p-1 text-gray-600" /> 28-day average
              </Button>
            </div>
          </div>
        }
      />
    </div>
  );
};

const About = () => <div>
  <h2 className="text-lg font-semibold mb-2">About Profit/Loss</h2>
  <p className="text-sm text-gray-600">
    The Profit/Loss report provides insights into the financial performance of your business over a specified period. It includes revenue, costs, and profit calculations to help you understand your profitability.
  </p>
</div>;

const Filter = () => {
  const [activeComponent, setActiveComponent] = useState("Explore");

  return (
    <div className="max-w-[250px] xl:max-w-[400px] w-full h-full border-l-[0.5px] p-4">
      <div className="flex space-x-4 mb-4">
        <button
          onClick={() => setActiveComponent("Explore")}
          className={activeComponent === "Explore" ? "" : "text-gray-500"}
        >
          Explore
        </button>
        <button
          onClick={() => setActiveComponent("About")}
          className={activeComponent === "About" ? "" : "text-gray-500"}
        >
          About
        </button>
      </div>
      {activeComponent === "Explore" && <Explore />}
      {activeComponent === "About" && <About />}
    </div>
  );
};

export default Filter;
